import React from "react";

import classNames from "classnames";

import { Tab } from "clearsense-ui/components";

const Tabs = ({ currentTab, setCurrentTab }) => (
  <Tab className="border-b uppercase overflow-y-auto mt-2 mb-4">
    <Tab.Item
      active={currentTab === "simple"}
      className={classNames("flex-none", {
        "dark:text-cs-ui-gray-400": currentTab === "simple",
      })}
      onClick={() => setCurrentTab("simple")}
    >
      SIMPLE
    </Tab.Item>
    <Tab.Item
      active={currentTab === "customSQL"}
      className={classNames("flex-none", {
        "dark:text-cs-ui-gray-400": currentTab === "customSQL",
      })}
      onClick={() => setCurrentTab("customSQL")}
    >
      CUSTOM SQL
    </Tab.Item>
  </Tab>
);

export default Tabs;
